<template>
  <header>
    <div class="left" v-if="false">
      <search />
    </div>
    <div class="right">
      <right-header />
    </div>

    <live-update-controller channel="call-logs" @signal="getCallLogs" />
  </header>
</template>

<script>
import { createNamespacedHelpers } from 'vuex-composition-helpers';
import LiveUpdateController from '@/components/LiveUpdateController';

import Search from './Search';
import RightHeader from './RightHeader';

const { useActions: usePhoneActions } = createNamespacedHelpers('phone');

export default {
  name: 'Header',
  components: {
    Search,
    RightHeader,
    LiveUpdateController,
  },
  setup() {
    const { getCallLogs } = usePhoneActions(['getCallLogs']);

    return {
      getCallLogs,
    };
  }
};
</script>

<style lang="scss">
@import "~@/assets/scss/colors";
@import "~@/assets/scss/dimens";

header {
  height: 70px;
  background-color: $babyPowder;
  box-shadow: 0px 2px 6px $shadow;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  padding: 12px 50px;
  padding-left: calc(#{$sidePanelWidth} + 20px);
  z-index: 98;

  .left {
    float: left;
    height:100%;
    box-shadow: 0px 3px 6px #00000029;
    border-radius: 23px;
  }

  .right {
    float: right;
    height: 100%;
    user-select: none;
  }
}
</style>
